import { Directive, ElementRef, inject, Input, OnDestroy, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[translate-lang]',
  standalone: true,
})
export class TranslateItalicDirective implements OnDestroy {
  @Input('translate-lang') langKeys!: Record<string, string>[];
  @Input('label') label!: string;

  private readonly el = inject(ElementRef);
  private readonly translate = inject(TranslateService);
  private readonly renderer = inject(Renderer2);
  private readonly REGEX_ITALIC = /\[italic=([^\]]+)\]/;

  langChangeSub: any;
  defaultLang: any;

  mapSelectors = new Map<string, string>([
    ['CUSTOM-BUTTON', 'dxc-button span.mdc-button__label span'],
    ['DXC-WIZARD-STEP', 'button div.infoContainer p.label'],
    ['EXTRA-BOX', 'div.container_extra div.header div label'],
    ['CUSTOM-INPUT-TEXT', 'dxc-text-input label.inputLabel'],
  ]);

  ngOnInit() {
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.updateTranslation();
    });
  }

  ngAfterViewChecked(): void {
    this.updateTranslation();
  }

  ngOnDestroy() {
    this.langChangeSub?.unsubscribe();
  }

  private updateTranslation() {
    if (!this.langKeys || this.langKeys.length === 0 || Object.keys(this.langKeys[0]).length === 0) return;
    const key = this.langKeys.find((k) => k[this.translate.currentLang]?.[this.translate.currentLang]) || this.langKeys[0];
    const translation = key?.[this.translate.currentLang] || this.label;
    this.defaultLang = key?.['default'];

    const formatted = this.formatTranslation(translation || this.defaultLang);
    const tagName = this.mapSelectors.get(this.el.nativeElement.tagName);
    if (!tagName) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', formatted);
      return;
    }
    const target = this.el.nativeElement.querySelector(tagName);
    if (target) {
      this.renderer.setProperty(target, 'innerHTML', formatted);
    }
  }

  private formatTranslation(input: string): string {
    if (!input) return '';
    input = input.replace(this.REGEX_ITALIC, ' <i>$1</i>');
    const baseKeyMatch = input.match(/^([^\s<]+)/);
    if (!baseKeyMatch) return input;
    const baseTranslationKey = baseKeyMatch[0].trim();
    const restOfString = input.slice(baseTranslationKey.length).trim();
    const translatedBase = this.translate.instant(baseTranslationKey) || baseTranslationKey;
    return `${translatedBase} ${restOfString}`.trim();
  }
}
